import { Box, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
const ActionButtons = ({
  labelSubmit = 'valider',
  disabled = false,
  onGoBack,
  onSubmit = () => {},
  loading = false,
}) => {
  const navigate = useNavigate()
  const { sfId } = useParams()
  const { t } = useTranslation()
  return (
    <Box display="flex" justifyContent="flex-end" gap={2} mt={2}>
      <Button size={'small'} onClick={() => {
        (!sfId.includes('@') ? navigate(`/contacts/list/${sfId}`) : navigate('/contacts'))
      }}
      >{t('auth.admin.edit.cancel')}
      </Button>
      {Boolean(onGoBack) && (
        <Button color="primary" variant="contained" onClick={onGoBack} size={'small'}>
          {t('ui_elements.form_previous')}
        </Button>
      )}
      <Button color="primary" variant="contained" onClick={onSubmit} disabled={loading || disabled} size={'small'}>
        {loading ? t('auth.admin.edit.save.loading') : labelSubmit}
      </Button>
    </Box>
    )
}
export default ActionButtons
